// extracted by mini-css-extract-plugin
export var lg = "_g8-7";
export var md = "_g8-6";
export var placeholderContainer = "_g8-1";
export var placeholderIcon = "_g8-2";
export var productImage = "_g8-0";
export var sm = "_g8-5";
export var xl = "_g8-8";
export var xs = "_g8-4";
export var xxs = "_g8-3";